<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 230.288"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M58.922 104.011c-3.314,0.726 -6.648,0.969 -10.001,0.729 -4.647,24.612 -3.447,56.098 0.77,93.625 2.792,-30.155 1.74,-58.493 9.231,-94.354z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M35.861 81.58c4.979,8.803 12.059,14.292 19.887,14.247 7.677,-0.044 14.268,-5.861 18.993,-14.633 0.995,-1.847 1.907,-3.825 2.729,-5.908 -2.823,-1.392 -5.637,-2.422 -8.441,-3.089 -5.627,-1.339 -11.214,-1.218 -16.763,0.362 -5.507,1.569 -10.976,4.576 -16.405,9.021z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M51.824 45.249c0.61,9.668 0.75,18.721 0.442,27.31 5.549,-1.58 11.136,-1.701 16.763,-0.362 -2.298,-7.267 -3.809,-16.153 -4.531,-26.659 -0.731,-10.632 -0.655,-22.922 0.229,-36.87 -3.162,-1.408 -6.415,-2.192 -9.491,-2.338 -2.794,-0.133 -5.358,0.241 -7.699,1.058 2.138,13.687 3.553,26.22 4.287,37.861z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthRight}"
            @click="select('fourthRight')"
            d="M64.727 8.668c-0.884,13.948 -0.96,26.238 -0.229,36.87 6.661,-0.257 12.763,-0.677 18.307,-1.258 0.3,-6.483 0.336,-12.876 -1.582,-17.945 -3.294,-8.706 -9.684,-14.635 -16.496,-17.667z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdLeft}"
            @click="select('thirdLeft')"
            d="M51.824 45.249c-7.371,1.716 -15.121,2.264 -23.246,1.644 -0.053,1.431 -0.074,2.879 -0.066,4.34 0.052,9.1 1.738,17.556 4.591,24.604 0.825,2.038 1.748,3.959 2.758,5.743 5.429,-4.445 10.898,-7.452 16.405,-9.021 0.308,-8.589 0.168,-17.642 -0.442,-27.31z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthLeft}"
            @click="select('fourthLeft')"
            d="M28.578 46.893c8.125,0.62 15.875,0.072 23.246,-1.644 -0.734,-11.641 -2.149,-24.174 -4.287,-37.861 -12.141,4.24 -18.262,20.401 -18.959,39.505z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdRight}"
            @click="select('thirdRight')"
            d="M64.498 45.538c0.722,10.506 2.233,19.392 4.531,26.659 2.532,0.602 5.072,1.5 7.619,2.694 0.275,0.126 0.55,0.257 0.824,0.39 2.851,-7.225 4.619,-15.71 5,-24.357 0.097,-2.192 0.23,-4.424 0.333,-6.644 -5.544,0.581 -11.646,1.001 -18.307,1.258z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M28.512 51.233c-0.142,-24.714 8.361,-45.78 26.724,-44.903 9.703,0.463 21.164,7.257 25.987,20.005 2.575,6.806 1.628,15.996 1.249,24.589 -1.012,22.982 -11.822,44.818 -26.724,44.903 -14.901,0.085 -27.095,-19.88 -27.236,-44.594zm4.591 24.604c0.587,70.219 4.564,118.06 11.932,143.521 9.649,18.867 17.338,0.853 16.151,-57.506 -0.535,-19.229 4.372,-46.115 13.555,-80.658"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
